// extracted by mini-css-extract-plugin
export default {"main":"App_main__Ouif1","open":"App_open__uF+gr","closed":"App_closed__lpHbX"};